import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Button from '@/components/UI/button/Button';
import MidTermGoftino from '@/components/reusable/midTermGoftino/MidtermGoftino';
import { FC, useState } from 'react';
import styles from './GoftinoSection.module.scss';
import Typography from '@/components/UI/typography/Typography';
type GoftinoSectionProps = {
  handleCloseSecttion: () => void;
  isMidTerm: boolean;
};
const GoftinoSection: FC<GoftinoSectionProps> = ({
  handleCloseSecttion,
  isMidTerm
}) => {
  const [showMidtermGoftino, setShowMidtermGoftinoe] = useState(false);
  const handleGoftino = e => {
    if (isMidTerm) {
      setShowMidtermGoftinoe(true);
    } else {
      if ((window as any).isGoftinoReady) {
        ;
        (window as any).Goftino.open();
      }
    }
  };
  const handleClose = () => {
    setShowMidtermGoftinoe(false);
  };
  return <>
      {showMidtermGoftino && <MidTermGoftino onClose={handleClose} />}

      <Box className={styles['goftion-section']} data-sentry-element="Box" data-sentry-source-file="GoftinoSection.tsx">
        <Box className={styles['goftino-content']} onClick={handleGoftino} data-sentry-element="Box" data-sentry-source-file="GoftinoSection.tsx">
          <Icon type="primary" name="messages-2-Filled" data-sentry-element="Icon" data-sentry-source-file="GoftinoSection.tsx" />
          <Typography color="secondary_main" variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="GoftinoSection.tsx">
            سوالی درباره اقامتگاه دارید؟
          </Typography>
          <Typography color="primary_main" variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="GoftinoSection.tsx">
            گفتگو با پشتیبانی
          </Typography>
        </Box>

        <Box className={styles['goftino-close']} data-sentry-element="Box" data-sentry-source-file="GoftinoSection.tsx">
          <Button format="text" onClick={handleCloseSecttion} data-sentry-element="Button" data-sentry-source-file="GoftinoSection.tsx">
            <Icon type="mediumEmphasis" name="close" data-sentry-element="Icon" data-sentry-source-file="GoftinoSection.tsx"></Icon>
          </Button>
        </Box>
      </Box>
    </>;
};
export default GoftinoSection;